// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2sq_r","bigColWidth":"Table_bigColWidth__29Xhr","biggerColWidth":"Table_biggerColWidth__3LcEK","row":"Table_row__3MQQL","col":"Table_col__Soy6V"};